import Main from './components/Main';
import Header from './components/Header';
import Footer from './components/Footer';
import './css/App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
